import React, { useRef } from "react";
import { useEffect, useState } from "react";
import { get, post } from "../../../utils/HttpRequest";
import config from "../../../config/config.json";
import { Toast } from "primereact/toast";
import { Col, Form, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion } from "@fortawesome/free-solid-svg-icons";

const LessonAcknowledge = () => {
  const toast = useRef(null);
  const [requireAuthenticationForLessonAcknowledgement, setRequireAuthenticationForLessonAcknowledgement] = useState(false);
  const [enableNavBarItems, setEnableNavBarItems] = useState(false);

  const getShowRequireAuthenticationForLessonAcknowledgement = async () => {
    try {
      const url = config.api.url + "getTrialConfig/requireAuthenticationForLessonAcknowledgement";
      get(url).then((response) => {
        setRequireAuthenticationForLessonAcknowledgement(response.data.value);
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleShowRequireAuthenticationForLessonAcknowledgement = async () => {
    try {
      setRequireAuthenticationForLessonAcknowledgement(!requireAuthenticationForLessonAcknowledgement);
      const formData = {
        name: "requireAuthenticationForLessonAcknowledgement",
        value: !requireAuthenticationForLessonAcknowledgement,
      };
      var url = config.api.url + "updateTrialConfig";
      post(url, formData)
        .then((response) => {
          if (response.status === 201 || response.status === 200) {
            getShowRequireAuthenticationForLessonAcknowledgement();
            toast.current.show({
              severity: "success",
              summary: "Lesson acknowledgement toggle has been updated",
              detail: "Success",
            });
          } else {
            toast.current.show({
              severity: "error",
              summary: "something want wrong",
              detail: "something want wrong",
            });
          }
        })
        .catch(function (error) {
          if (error.response.status === 400 || error.response.status === 401) {
            toast.current.show({
              severity: "error",
              summary: "something want wrong",
              detail: "something want wrong",
            });
          }
        });
    } catch (error) {
      console.error("Error making API call:", error);
    }
  };

  useEffect(() => {
    getShowRequireAuthenticationForLessonAcknowledgement();
  }, []);

  return (
    <div className="app">
      <Toast ref={toast}></Toast>
      <hr />
      <Row>
        <Col lg={6}>
          <span className="card-title">Authentication for acknowledgement</span>{" "}
          <hr />
              <h6 className="card-title">Lesson/Assessment Acknowledgement Authentication</h6>
              <Form id="settingsRequireAuthenticationForLessonAcknowledgement">
                <div className="form-check mb-3">
                  <label
                    className="form-check-label"
                    htmlFor="requireAuthenticationForLessonAcknowledgementSettings"
                  >
                    Requires Authentication for Lesson/Assessment Acknowledgement
                    <span
                      className="pl-2"
                      title="Requires Authentication"
                      style={{ fontSize: "1.1rem", fontWeight: "800" }}
                      aria-hidden="true"
                    >
                      <FontAwesomeIcon
                        icon={faCircleQuestion}
                        onClick={handleShowRequireAuthenticationForLessonAcknowledgement}
                      />
                    </span>
                  </label>
                  <div className="list-group-item border-none py-3 col-md-2">
                    <label className="switcher-control switcher-control-success">
                      <input
                        type="checkbox"
                        className="switcher-input switcher-control-success"
                        name="requireAuthenticationForLessonAcknowledgementSettings"
                        checked={requireAuthenticationForLessonAcknowledgement}
                        onClick={handleShowRequireAuthenticationForLessonAcknowledgement}
                      />
                      <span className="switcher-indicator"></span>
                    </label>
                  </div>
                </div>
              </Form>
        </Col>

      </Row>
    </div>
  );
};
export default LessonAcknowledge;
